import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { RepresentanteFormInputDisabledComponent } from './representante-form-input-disabled.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RepresentanteFormInputDisabledComponent
    ],
    exports: [
        RepresentanteFormInputDisabledComponent
    ]
})
export class RepresentanteFormInputDisabledModule { }
